import application from 'application/application';
import controller from './resync-svg.controller';

import template from './resync-svg.template.html';

application.directive('appResyncSvg', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				size: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
